<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Tracks</p>
          <Filters />
        </div>
        <el-table
          :data="data.data"
          :default-sort="{ prop: order_column, order: order_type }"
          @sort-change="sort"
          class="w100"
          stripe
        >
          <el-table-column type="expand" label="Details" width="100%">
            <template slot-scope="props">
              <div v-if="props.row.description" class="inline">
                <strong>Description</strong>
                <p>{{ props.row.description }}</p>
              </div>
              <div v-if="props.row.keywords" class="inline">
                <strong>Keywords</strong>
                <p>{{ props.row.keywords }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Title"
            prop="title"
            sortable
          ></el-table-column>
          <el-table-column
            label="Author"
            prop="author"
            sortable
          ></el-table-column>
          <el-table-column
            label="Performer"
            prop="performer"
            sortable
          ></el-table-column>
          <el-table-column
            label="Album title"
            prop="album_title"
            sortable
          ></el-table-column>
          <el-table-column
            label="Song length"
            prop="song_length"
            sortable
          ></el-table-column>
          <el-table-column
            label="Previews"
            prop="num_previews"
            sortable
          ></el-table-column>
          <el-table-column
            label="Purchases"
            prop="num_purchases"
            sortable
          ></el-table-column>
          <el-table-column label="Published date" sortable>
            <template slot-scope="props">
              {{ props.row.published_at_utc | date }}
            </template>
          </el-table-column>
          <el-table-column label="Actions" align="right">
            <template slot-scope="props">
              <el-tooltip content="Open on SyncVault" placement="right">
                <el-button
                  type="success"
                  circle
                  size="small"
                  icon="el-icon-zoom-in"
                  @click="openSB(props.row.id)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="float-right"
          background
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="data.current_page"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="data.total"
        ></el-pagination>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '../components/Filters'
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  components: {
    Filters
  },

  computed: {
    ...mapState('track', [
      'data',
      'page',
      'page_size',
      'order_column',
      'order_type',
      'loading'
    ])
  },

  methods: {
    ...mapActions('track', ['read']),
    ...mapMutations('track', ['setPage', 'setPageSize', 'setOrdering']),

    openSB(id) {
      window.open(`https://syncvault.com/track/${id}`, '_blank')
    },
    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.read()
    },
    currentChange(page) {
      this.setPage(page)
      this.read()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.read()
    }
  },

  created() {
    this.read()
  }
}
</script>
